import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './MasikKala.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';
import city from '../../../city.json'


function formatTime(rawTime, formatType = "24") {
  const [hoursStr, minutes] = rawTime.split(":");
  let hours = parseInt(hoursStr, 10);

  if (formatType === "12" || formatType === "12hr") {
    const period = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;
    return `${hour12}:${minutes} ${period}`;
  }

  if (formatType === "24+" || formatType === "24hr+") {
    return `${rawTime} hrs`;
  }

  return rawTime;
}



const MasikKala = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('Kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

    const [KalaList, setKalaList] = useState([]);
     const [tempLocation, setTempLocation] = useState("Kolkata");
    const [suggestions, setSuggestions] = useState([]);
    const [selectedKala, setSelectedKala] = useState(null);

  

  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const kalashtamiTooltips = {
  "Kalashtami": "Kalashtami is a monthly observance dedicated to Lord Bhairava, a fierce manifestation of Lord Shiva. Devotees fast and offer prayers for protection from negative energies and to overcome fear and obstacles.",
  "Kalabhairav Jayanti": "Kalabhairav Jayanti marks the birth anniversary of Lord Kalabhairava. It is considered highly auspicious to worship Lord Bhairava on this day to remove sins, gain protection, and attain spiritual growth."
};


useEffect(() => {
  const fetchKalaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/kalashtami?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.kalashtamiDates) {
        setKalaList(response.data.kalashtamiDates);
      } else {
        setKalaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch kalashtami data:", error);
      setKalaList([]);
    }
  };

  fetchKalaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

 const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED for API refetch
  setSuggestions([]);
};


  return (
    <div className="MasikKala-container">
      <InnerNav />
      <div className="MasikKala-content">
        <Zodiac />

        {/* Ekadashi Calendar JSX starts here */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Masik Kalastami Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="Kala-controls">
                 <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedKala ? (
  <div className="kala-list">
    {KalaList.length === 0 && (
      <p>No kalastami puja data available for selected year/location.</p>
    )}

    {KalaList.map((item, idx) => (
      <div
        className="kala-item clickable"
        key={idx}
        onClick={() => setSelectedKala(item)}
      >
        <img
          src="https://i.pinimg.com/736x/de/fe/da/defeda16bb6caa3d22589f3fe220c267.jpg"
          alt={item.title}
        />

        <div className="kala-details">
          <p className="kala-date">{item.date}</p>
          <div className="kala-name">{item.title}</div>
          <p className="kala-phase">{item.day}</p>
          <p className="kala-tithi">{item.month}</p>
          <p className="kala-tithi">{item.duration}</p>
        </div>

        <div className="kala-timings">
          <p>{item.lunarDetail}</p>
          <p>Begins: {formatTime(item.begins, timeFormat)}</p>
          <p>Ends: {formatTime(item.ends, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="kala-detail-view">
    <button className="back-btn" onClick={() => setSelectedKala(null)}>
      ← Back
    </button>

    <h2 className="detail-title">{selectedKala.title}</h2>

    <img
      className="detail-image"
      src="https://i.pinimg.com/736x/de/fe/da/defeda16bb6caa3d22589f3fe220c267.jpg"
      alt={selectedKala.title}
    />

    {/* EVENT DETAILS */}
    <div className="detail-section">
      <h3>📅 Event Details</h3>
      <p><strong>Date:</strong> {selectedKala.date}</p>
      <p><strong>Day:</strong> {selectedKala.day}</p>
      <p><strong>Month:</strong> {selectedKala.month}</p>
      <p><strong>Duration:</strong> {selectedKala.duration}</p>
    </div>

    {/* TIMING DETAILS */}
    <div className="detail-section">
      <h3>⏰ Timing Information</h3>
      <p><strong>Begins:</strong> {formatTime(selectedKala.begins, timeFormat)}</p>
      <p><strong>Ends:</strong> {formatTime(selectedKala.ends, timeFormat)}</p>
    </div>

    {/* LUNAR DETAILS */}
    {/* <div className="detail-section">
      <h3>🌙 Lunar Details</h3>
      <p>{selectedKala.lunarDetail}</p>
    </div> */}

    {/* SIGNIFICANCE */}
    <div className="detail-section">
      <h3>🕉️ Significance</h3>
      <p>
        {kalashtamiTooltips[selectedKala.title] ||
          "Kalashtami is observed to seek the blessings of Lord Bhairava for protection, courage, fearlessness, and removal of negative influences."}
      </p>
    </div>
  </div>
)
}

        </div>
        {/* Ekadashi Calendar JSX ends here */}
         <section className="masikkalashtami-wrapper">
      <h1 className="masikkalashtami-title">Masik Kalashtami</h1>
      <div className="masikkalashtami-texts">
        <p>
          Kalashtami, which is also known as Kala Ashtami, is observed every month during Ashtami Tithi of Krishna Paksha. Devotees of Lord Bhairav keep fast and worship Him on all Kalashtami days in the year.
        </p>

        <p>
          The most significant Kalashtami, which is known as Kalabhairav Jayanti, falls in the month of Margashirsha according to North Indian, Purnima to Purnima, lunar month calendar while Kalabhairav Jayanti falls in the month of Kartik in South Indian, Amavasya to Amavasya, lunar month calendar. However both calendars observe Kalabhairav Jayanti on the same day. It is believed that Lord Shiva appeared in the form of Bhairav on the same day.
        </p>

        <p>
          Kalabhairav Jayanti is also known as Bhairav Ashtami.
        </p>

        <p>
          It should be noted that Kalashtami fasting might be observed on Saptami Tithi. According to religious texts, Kalashtami fasting should be observed on the day when Ashtami Tithi prevails during night. Ashtami should prevail at least for one Ghati after Pradosh while selecting fasting day for Kalashtami. Otherwise, Kalashtami fasting day is moved to previous day when Ashtami Tithi is more likely to prevail during night.
        </p>
      </div>
    </section>
            <VratLinks/>
        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default MasikKala;
